import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KSideMenuComponent } from './k-side-menu.component';
import { TranslocoModule } from '@ngneat/transloco';
import { KButtonModule } from '../k-button/k-button.module';
import { RouterModule } from '@angular/router';
import { KTooltipModule } from '../k-tooltip/k-tooltip.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { DirectivesModule } from 'app/common/directives/directives.module';
import { LanguageSwitchModule } from 'app/common/components/language-switch/language-switch.module';
import { TooltipModule } from 'primeng/tooltip';


@NgModule({
  declarations: [
    KSideMenuComponent
  ],
  imports: [
    CommonModule,
    TranslocoModule,
    KButtonModule,
    RouterModule, //to use routerLink in html
    KTooltipModule,
    FontAwesomeModule,
    DirectivesModule,
    LanguageSwitchModule,
    TooltipModule
  ],
  exports: [
    KSideMenuComponent
  ]
})
export class KSideMenuModule {
}
